import { useEffect } from 'react';
import { useAppSelector } from '../app/hooks';
import { selectTheme } from '../features/ui/uiSlice';

/** Keeps Pico's {@code data-theme} on the document in sync with the selected theme. */
export function useApplyTheme(): void {
  const theme = useAppSelector(selectTheme);
  useEffect(() => {
    document.documentElement.dataset['theme'] = theme;
  }, [theme]);
}
